import { ButtonIcon } from '@statsbomb/kitbag-components';
import { useAtomValue } from 'jotai';
import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import { styled } from 'styled-components';
import { selectedMetadataAtom } from '../../atoms/selectedMetadata';
import themeHelper from '../../utils/themeHelper';
import MetadataSelections from '../MetadataSelections';

const SearchContainer = styled.div`
  display: flex;
  gap: ${themeHelper.spacing()};
  justify-content: space-between;
`;
const SearchElementsContainer = styled.span`
  flex-grow: 1;
`;
const ButtonContainer = styled.span`
  align-self: flex-end;
`;

export function MatchPeriodVideoSearch({ onVideoSearch }) {
  const intl = useIntl();

  const selectedMetadata = useAtomValue(selectedMetadataAtom);
  const { sport, matchId, period } = selectedMetadata;

  const disabled = !sport || !matchId || !period;

  return (
    <SearchContainer>
      <SearchElementsContainer>
        <MetadataSelections.MatchId required />
      </SearchElementsContainer>
      <SearchElementsContainer>
        <MetadataSelections.MatchPart />
      </SearchElementsContainer>
      <ButtonContainer>
        <ButtonIcon
          icon="Search"
          disabled={disabled}
          onClick={onVideoSearch}
          title={
            disabled
              ? intl.formatMessage({
                  defaultMessage: 'Search. Please select a match id and period',
                  id: '12808',
                })
              : intl.formatMessage({
                  defaultMessage: 'Search',
                  id: '13348',
                })
          }
        />
      </ButtonContainer>
    </SearchContainer>
  );
}

MatchPeriodVideoSearch.propTypes = { onVideoSearch: PropTypes.func.isRequired };

export default { MatchPeriodVideoSearch };
